import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { useNavigate } from 'react-router-dom';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import { useApi } from 'app/api/APIProvider';
import { formatNumber } from 'shared/lib/utils/utils';
import cls from './ConditionCard.module.scss';

interface ICondition {
    name: string,
    depositAmount?: string | number,
    refillPerYear?: string | number,
    percentageRate?: string | number,
    loanSum?: string | number,
    term?: string | number,
    contributionSum?: string | number,
    accumulated?: string | number,
    wallet?: number,
    totalSum?: string | number,
    button?: {
        url: string
    }
}

interface ConditionCardProps {
    conditions: ICondition,
}

export const ConditionCard = ({ conditions }: ConditionCardProps) => {
    const api = useApi();
    const navigate = useNavigate();
    const { name, depositAmount, refillPerYear, percentageRate, term, loanSum, wallet, totalSum, contributionSum, accumulated, button } = conditions;
    return (
        <div className={cls.card}>
            <div>
                <Title className={cls.title} color="#353850" size={TitleSize.title_20}>{name}</Title>
                <div className={cls.flexWrapper}>
                    {
                        contributionSum && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Сумма взноса</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(contributionSum))} ₽</Text>
                    </div>
                    }
                    {
                        depositAmount && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Сумма вклада</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(depositAmount))} ₽</Text>
                    </div>
                    }
                    {
                        loanSum && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Сумма кредита</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(loanSum))} ₽</Text>
                    </div>
                    }
                    {
                        refillPerYear && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Сумма пополнения в год</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(refillPerYear))} ₽</Text>
                    </div>
                    }
                    {
                        percentageRate && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Процентная ставка</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{percentageRate}</Text>
                    </div>
                    }
                    {
                        term && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Срок</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{term}</Text>
                    </div>
                    }
                    {
                        wallet && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Остаток на счете</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(wallet))} ₽</Text>
                    </div>
                    }
                    {
                        accumulated && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Накоплено</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(accumulated))} ₽</Text>
                    </div>
                    }
                    {
                        totalSum && <div className={cls.flexBlock}>
                        <Text color="#7B7B7B" size={TextSize.text_18}>Итого</Text>
                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(Number(totalSum))} ₽</Text>
                    </div>
                    }
                </div>
            </div>
            {
                button && <Button
                    className={cls.button}
                    theme={ButtonTheme.BUY}
                    onClick={async () => {
                        navigate(button.url);
                    }}
                >
                    Отказаться
                </Button>
            }
        </div>
    );
};
